import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';
import './nlp/imageclassify.css';
import bulk from './nlp/imageclassify.js';
import dash from './dashboardTools.js';
import plotly from './plotlyTools.js'

import './panel.css';
// import './jquery-simple-upload.css';
// import '@kanety/jquery-simple-upload';

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
	var ret = [];
	for (var i = 0; i < n; i++)
		ret.push(v instanceof Object ? clone(v) : v);
	return ret;
}

function error(s) {
	var err = $('<div role="alert" class="fade alert alert-danger show">').html(s);
	$('.maincontent').html('').append(err);
}


function bool(s) {
	if (typeof (s) == 'boolean') return s;
	if (!defined(s) || s === null) return false;
	if (typeof (s) == 'number') return s > 0;
	if (s.match(/^y/i)) return true;
	return false;
}

function sbool(v) {
	return ['No', 'Yes'][v];
}

var dashboardVisible = null;
var projectData = null;
var lcolors = [];
var metricsResult = null;

var descriptor = {
	"labels": [
		{
			"label": "Some Label"
		}
	],
	"dataset": [
		{
			"imageUrl": "https://hddesktopwallpapers.in/wp-content/uploads/2015/09/toucan-bird.jpg",
			"label": "Toucan",
			"metadata": {
				"hello": "world",
				"situation": "nature",
				"tags": [
					"some",
					"test"
				]
			},
			"fileId": "09a634648e99fcba16b1fd235a390983",
			"classification": "Neutrophil",
			"selected": true,
		}
	],
	"imageLayout": {
		"showLabels": true,
		"showDetails": true,
		"showControls": false
	},
	"detailLayout": {
		"policy": "doubleclick",
		"doubleSize": 2,
		"showLabels": true,
		"showDetails": true,
		// "showControls": true
	},
	"imageControls": {
		"redAdjust": true,
		"greenAdjust": true,
		"blueAdjust": false,
		"brigtnessAdjust": true
	},
	"gridLayout": {
		"imageZoom": 8,
		"itemsPerPage": 40,
		"filter": {
			"globalFilter": true,
			"keyFilter": true,
			"annotation": true
		},
		"toggleLabels": false,
		"toggleDetails": true,
		"toggleControls": true
	},
	"userRole": {
		// "email": "marcelo@me.com",
		// "role": "nlp_an"
		"role": "admin",
	},
	// "classificationMode": true,
	"selectionMode": "multi",
	"blockEdit": false,
	"adminEdit": false,
	"projectMode": true,
}


var global = window.GlobalVars;
var tasks = null;
var project = null;

function BulkBrowse(prop) {

	var global = window.GlobalVars;
	var tab;

	function sortCount(a) {
		try {
			var scount = [];
			for (var k in a) {
				scount.push([k, a[k]]);
				delete a[k];
			}
			scount.sort((a, b) => a[1] > b[1] ? -1 : 1);
			for (var i of scount) a[i[0]] = i[1];
		} catch (e) { console.error(e) }
	}

	var aname = null;
	function dashboard(but) {
		if (!dashboardVisible) return;
		var db = $('#dashboard');
		db.html('').append($(`
				<div class="container-fluid">
				</div>
		`));

		var ncharts = 0;
		var chartRow = null;
		function addChartDiv() {
			if (!(ncharts % 2)) {
				chartRow = $('<div class="row">');
				db.find('.container-fluid').append(chartRow)
			}
			var divCont = $('<div class="ccol-sm col-6 chart-' + ncharts + '">')
			var div = $('<div class="dashboard-cell">')
			divCont.append(div);
			chartRow.append(divCont);
			ncharts++;
			return div;
		}

		// var recs = tab.baseRows.map( r => r.data.origData );
		// console.log( 'dash recs', recs );
		var labels = projectData.labels;

		console.log( 'projectData', projectData )
		// var annotators = projectData.annotators;
		// var qcs = projectData.qcs;
		var states = projectData.states;

		var annotators = {};
		for( var a in projectData.annotators ) {
			var sa = a.replace(/\*/g, '.');
			annotators[sa] = projectData.annotators[a];
		}
		var qcs = {};
		for( var a in projectData.qcs ) {
			var sa = a.replace(/\*/g, '.');
			qcs[sa] = projectData.qcs[a];
		}

		if (!aname) {
			var emails = {};
			for (var e in annotators) emails[e] = 1;
			for (var e in qcs) emails[e] = 1;
			emails = Object.keys(emails).map( e => e.replace(/\*/g, '.'));
			console.log('EMAILS', emails);
			window.post('find_users', { match: { email: { $in: emails } } }, function (res) {
				aname = {};
				for (var u of res.data.records) {
					aname[u.email] = u.name;
				}
				dashboard();
			})
			return;
		}

		var showConsensusDash = true;
		sortCount(labels);
		console.log('totlabels', labels);
		console.log('annotators', annotators, aname);
		console.log('states', states);

		function val(v) { return v.toFixed(1) }
		function ival(v) { return v.toFixed(0) }
		function labelColor(l) {
			if (descriptor.labels && descriptor.labels[l]) return descriptor.labels[l].color;
			if (descriptor.relationships && descriptor.relationships[l]) return descriptor.relationships[l].color;
			if (descriptor.boxes && descriptor.boxes[l]) return descriptor.boxes[l].color;
			return '#ff0000';
		}

		var training = descriptor.projectData.training;
		var trainingType = training ? descriptor.projectData.descriptor.training.type : 0;

		var stateColor = [
			'#cccccc',
			'#333377',
			'#ff8833',
			'#ff8800',
			'#00cc00',
			'#cc0000',
			'#ff8833',
			'#00cc00',
			'#cc0000',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cccccc',
			'#cc0000',
			'#cc0000',
		]
		var scolors = [];

		if( !trainingType ) {
			// Task State

			// var cfg = {
			// 	container: addChartDiv(),
			// 	title: 'Task States',
			// 	// max: 100,
			// 	format: ival,
			// 	formatTooltip: ival,
			// 	formatTick: ival,
			// 	paddingY: 30,
			// 	rotated: false,
			// 	// dataColor: function(c,d){ console.log( 'DATACOLOR', c, d ); return lcolors[d.x % lcolors.length]},
			// 	colorPattern: scolors,
			// 	// size:{height:500},
			// 	// basevalue:getVal,
			// 	// hideLegends: true,
			// 	hideY: true,
			// };
			var d = {
				"values": [[]],
				"xLabels": ['Count'],
				"yLabels": [],
			};
			for (var l in states) {
				scolors.push(stateColor[l]);
				d.yLabels.push(window.window.stateLabels[l]);
				d.values[0].push(states[l])
			}

			let xDataArray = [];

		if(d.values.length > 1){
			for(let [index, xValue] of d.values.entries()){
				let trace = {};
				trace = {
					values: xValue,
					domain: {column: index},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
			}
		}else if(d.values.length == 1){
			let trace = {};
				trace = {
					values: d.values.flat(),
					domain: {column: 0},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
		}

		let data = {
            xData : xDataArray,
            labels: d.yLabels,
            container : addChartDiv()[0],
            grid : { rows: Math.ceil((xDataArray.length)/2), columns: xDataArray.length}
        }

		let config = {
			chartTitle: 'Task States',
            size: {
                height: '400',
                width: '650'
            },
		}

		plotly.drawDonutChart(data, config);
			// dash.drawGraphDonut(d, cfg);

			// labels Dashboard
			var labMax = 15;
			var llist = [];
			for (var l in labels) { llist.push({ name: l, count: labels[l] }) }
			llist.sort((a, b) => a.count > b.count ? -1 : 1)
			var tit = 'Label Distribution';
			if (llist.length > labMax) tit = 'Top Labels';
			llist.splice(labMax, 10000);
	
			lcolors = [];
			lcolors = frm.paletteWheel(llist.length);
			// var cfg = {
			// 	container: addChartDiv(),
			// 	title: tit,
			// 	format: ival,
			// 	formatTooltip: ival,
			// 	formatTick: ival,
			// 	paddingY: 30,
			// 	rotated: true,
			// 	dataColor: function (c, d) { return lcolors[d.x % lcolors.length] },
			// 	hideLegends: true,
			// 	hideY: true,
			// };
			var d = {
				"values": [],
				"xLabels": [],
				"yLabels": ["Label count"]
			};
			for (var l of llist) {
				// lcolors.push( labelColor(l) );
				d.xLabels.push(l.name);
				d.values.push([l.count])
			}

			let xValuesArray2 = [];
		let xDataArray2 = [];

		if(Array.isArray(d.values[0])){
			for (let j in d.values[0]) {
				let row = [];
				for (let i in d.values) {
					row.push(d.values[i][j]);
				}
				xValuesArray2.push(row);
			}
	
			for(let xValue of xValuesArray2){
				let trace = {};
				trace = {
                    values: xValue,
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
                }
				xDataArray2.push(trace)
			}
		}else{
			let trace = {};
			trace = {
				values: d.values,
				// name: 'bar1',
				color: function (c, d) { return lcolors[d % lcolors.length] },
				orientation: 'h',
			}
			xDataArray2.push(trace)
		}

		let data2 = {
            xData : xDataArray2,
            showXlabels: false,
            yValues: d.xLabels,
            yLabel: 'Label count',
            container : addChartDiv()[0]
        }
    
        let config2 = {
            chartTitle: tit,
            size: {
                height: '650',
                width: '400'
            },
            // barmode: false,
            // dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

		plotly.drawBarChart(data2, config2)
		// dash.drawGraphBar(d, cfg);
		}
		else if (trainingType == 3) { // if qualification
			// Qualification states

			var threshold = descriptor.projectData.descriptor.training.threshold;
			scolors = [];
			var qStateColor = {
				'Qualified': '#00ff00',
				'In progress': '#999999',
				'Failed': '#ff0000',
			}
			var states = {};
			var aScore = {};
			var annotatorScore = {};
			// for (var i of descriptor.imageList) {
			// 	if (!i.taskAnnotations) continue;
			// 	// var finalClassification = i.finalClassification;
			// 	for (var t of i.taskAnnotations) {
			// 		let email = t.email;
			// 		if (email.indexOf('@') == -1) continue;
			// 		if (!annotatorScore[email]) annotatorScore[email] = { count: 0, correct: 0 };
			// 		annotatorScore[email].count++;
			// 		if (t.annotations.classification == i.finalClassification) annotatorScore[email].correct++;
			// 		var ts = Math.floor(new Date(t.date).getTime()/1000);
			// 		if( !annotatorScore[email].updated ) annotatorScore[email].updated = 0;
			// 		annotatorScore[email].updated = Math.max( annotatorScore[email].updated, ts )
			// 	}
			// }
			for (var a in projectData.aScore) {
				var e = a.replace(/\*/g, '.');
				annotatorScore[e] = projectData.aScore[a];
				annotatorScore[e].state = 'In progress';
				if (annotatorScore[e].count == projectData.num_files) {
					var as = annotatorScore[e];
					var score = 100 * as.correct / as.count;
					var threshold = projectData.descriptor.training.threshold;
					as.state = score >= threshold ? 'Qualified' : 'Failed';
					as.score = score;
					var scoreTier = Math.floor(score / 10) * 10;
					if (!aScore[as.state]) aScore[as.state] = {};
					if (!aScore[as.state][scoreTier]) aScore[as.state][scoreTier] = 0;
					aScore[as.state][scoreTier]++;
				}
				if (!states[as.state]) states[as.state] = 0;
				states[as.state]++;
			}
			// var imageCount = descriptor.imageList.length;
			// for (var an in annotatorScore) {
			// 	let as = annotatorScore[an];
			// 	if (as.count < imageCount) {
			// 		as.state = 'In progress';
			// 	} else {
			// 		var score = 100 * as.correct / as.count;
			// 		var scoreTier = Math.floor(score / 10) * 10;
			// 		as.score = score;
			// 		as.state = score >= threshold ? 'Qualified' : 'Failed';
			// 		if (!aScore[as.state]) aScore[as.state] = {}
			// 		if (!aScore[as.state][scoreTier]) aScore[as.state][scoreTier] = 0
			// 		aScore[as.state][scoreTier]++
			// 	}
			// 	if (!states[as.state]) states[as.state] = 0;
			// 	states[as.state]++;
			// }
			console.log('annotatorScore', annotatorScore)
			console.log('states', states)
			console.log('aScore', aScore)

			// var cfg = {
			// 	container: addChartDiv(),
			// 	title: 'Qualification States',
			// 	// max: 100,
			// 	format: ival,
			// 	formatTooltip: ival,
			// 	formatTick: ival,
			// 	paddingY: 30,
			// 	rotated: false,
			// 	colorPattern: scolors,
			// 	hideY: true,
			// };
			var d = {
				"values": [[]],
				"xLabels": ['Count'],
				"yLabels": [],
			};
			for (var l in states) {
				scolors.push(qStateColor[l]);
				// d.yLabels.push(l.replace(/ /g, '&nbsp;'));
				d.yLabels.push(l);
				d.values[0].push(states[l])
			}

			let xDataArray = [];

		if(d.values.length > 1){
			for(let [index, xValue] of d.values.entries()){
				let trace = {};
				trace = {
					values: xValue,
					domain: {column: index},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
			}
		}else if(d.values.length == 1){
			let trace = {};
				trace = {
					values: d.values.flat(),
					domain: {column: 0},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
		}

		let data = {
            xData : xDataArray,
            labels: d.yLabels,
            container : addChartDiv()[0],
            grid : { rows: Math.ceil((xDataArray.length)/2), columns: xDataArray.length }
        }

		let config = {
			chartTitle: 'Qualification States',
            size: {
                height: '460',
                width: '600'
            },
		}

		plotly.drawDonutChart(data, config);
		// dash.drawGraphDonut(d, cfg);

			// scores distribution treemap

			var tit = 'Qualification scores distribution';
			var cfg = {
				container: addChartDiv(),
				title: tit,
			};
			var treeData = dash.treemapNode(tit);
			for (var st of ['Qualified', 'Failed']) {
				if (aScore[st]) {
					let tn = dash.treemapNode(st, 0, treeData);
					for (var sc in aScore[st]) {
						dash.treemapNode(sc + '%', aScore[st][sc], tn);
					}
				}
			}
			console.log('TREEDATAQUALI', treeData)

			dash.drawTreemap(treeData, cfg);

		}

		else if (trainingType == 1) { // if training
			var threshold = descriptor.projectData.descriptor.training.threshold;
			scolors = [];
			var qStateColor = {
				'Qualified': '#00ff00',
				'Trained': '#00ff00',
				'In progress': '#999999',
				'Failed': '#ff0000',
			}
			var states = {};
			var aScore = {};
			var annotatorScore = {};
			console.log( 'ASCORE', projectData.aScore)

			console.log('annotatorScore', annotatorScore, 'annotators', annotators)
			for (var a in projectData.aScore) {
				var e = a.replace(/\*/g, '.');
				annotatorScore[e] = projectData.aScore[a];
				annotatorScore[e].state = 'In progress';
				if (annotatorScore[e].count == projectData.num_files) {
					var as = annotatorScore[e];
					var score = 100 * as.correct / as.count;
					var threshold = projectData.descriptor.training.threshold;
					as.state = 'Trained';
					as.score = score;
					var scoreTier = Math.floor(score / 10) * 10;
					if (!aScore[as.state]) aScore[as.state] = {};
					if (!aScore[as.state][scoreTier]) aScore[as.state][scoreTier] = 0;
					aScore[as.state][scoreTier]++;
				}
				if (!states[as.state]) states[as.state] = 0;
				states[as.state]++;
			}


			// var imageCount = descriptor.imageList.length;
			// for (var an in annotatorScore) {
			// 	let as = annotatorScore[an];
			// 	if (as.count < imageCount) {
			// 		as.state = 'In progress';
			// 	} else {
			// 		as.state = 'Trained';
			// 		if (!aScore[as.state]) aScore[as.state] = {}
			// 		if (!aScore[as.state][scoreTier]) aScore[as.state][scoreTier] = 0
			// 		aScore[as.state][scoreTier]++
			// 	}
			// 	if (!states[as.state]) states[as.state] = 0;
			// 	states[as.state]++;
			// }
			console.log('states', states)
			console.log('aScore', aScore)

			// var cfg = {
			// 	container: addChartDiv(),
			// 	title: 'Training States',
			// 	// max: 100,
			// 	format: ival,
			// 	formatTooltip: ival,
			// 	formatTick: ival,
			// 	paddingY: 30,
			// 	rotated: false,
			// 	colorPattern: scolors,
			// 	hideY: true,
			// };
			// var d = {
			// 	"values": [[]],
			// 	"xLabels": ['Count'],
			// 	"yLabels": [],
			// };
			// for (var l in states) {
			// 	scolors.push(qStateColor[l]);
			// 	// d.yLabels.push(l.replace(/ /g, '&nbsp;'));
			// 	d.yLabels.push(l);
			// 	d.values[0].push(states[l])
			// }
			// dash.drawGraphDonut(d, cfg);



			// // stores distribution treemap

			// var tit = 'Qualification scores distribution';
			// var cfg = {
			// 	container: addChartDiv(),
			// 	title: tit,
			// };
			// var treeData = dash.treemapNode(tit);
			// for (var st of ['Qualified', 'Failed']) {
			// 	if (aScore[st]) {
			// 		let tn = dash.treemapNode(st, 0, treeData);
			// 		for (var sc in aScore[st]) {
			// 			dash.treemapNode(sc + '%', aScore[st][sc], tn);
			// 		}
			// 	}
			// }
			// console.log('TREEDATAQUALI', treeData)

			// dash.drawTreemap(treeData, cfg);
			showConsensusDash = false;
		}

		// consensus distribution treemap
		var consensus = {};
		var consensusTot = {};
		// for (var fl in projectData.aConsensus) {
		// 	var cc = projectData.aConsensus[fl]
		// 	var ct = cc.count;
		// 	var cn = cc.consensus/ct;
		// 	cn = cn.toFixed(2)
		// 	console.log( 'aConsensus', fl, cn, ct, projectData.aConsensus[fl] )
		// 	if (!consensus[cn]) consensus[cn] = {};
		// 	if (!consensusTot[cn]) consensusTot[cn] = 0;
		// 	if (!consensus[cn][fl]) consensus[cn][fl] = 0;
		// 	consensus[cn][fl]++;
		// 	consensusTot[cn]++;
		// }
		consensus = projectData.aConsensus;
		consensusTot = projectData.tConsensus;

		// for (var i of descriptor.imageList) {
		// 	if (!i.annotationData || !i.annotationData.Consensus) continue;
		// 	var cn = i.annotationData.Consensus;
		// 	var fl = i.annotationData['Final Label'];
		// 	if (!consensus[cn]) consensus[cn] = {};
		// 	if (!consensusTot[cn]) consensusTot[cn] = 0;
		// 	if (!consensus[cn][fl]) consensus[cn][fl] = 0;
		// 	consensus[cn][fl]++;
		// 	consensusTot[cn]++;
		// }
		console.log( 'CCCCCCCCCCCCCCCCCCCconsensus', consensus, 'consensusTot', consensusTot )
		var cnkeys = Object.keys(consensus)
		if (showConsensusDash && cnkeys.length > 0) {
			var tit = 'Consensus Label Distribution';
			var cfg = {
				container: addChartDiv(),
				title: tit,
			};
			console.log('Consensus', consensus)
			var treeData = dash.treemapNode(tit);
			function cwalk(o, parent) {
				console.log('cwalk', o, parent)
				for (var k in o) {
					if (isobj(o[k])) {
						var n = dash.treemapNode(k, 0, parent);
						cwalk(o[k], n);
					}
					else dash.treemapNode(k, o[k], parent);
				}
			}
			cwalk(consensus, treeData);
			console.log('TREEDATA', treeData)

			dash.drawTreemap(treeData, cfg);

			// Task State

			// var scolors = [];
			lcolors = frm.paletteWheel(cnkeys.length);

			// var cfg = {
			// 	container: addChartDiv(),
			// 	title: 'Average Consensus Distribution across all tasks',
			// 	// max: 100,
			// 	format: ival,
			// 	formatTooltip: ival,
			// 	formatTick: ival,
			// 	paddingY: 30,
			// 	rotated: false,
			// 	// dataColor: function(c,d){ console.log( 'DATACOLOR', c, d ); return lcolors[d.x % lcolors.length]},
			// 	colorPattern: lcolors,
			// 	// size:{height:500},
			// 	// basevalue:getVal,
			// 	// hideLegends: true,
			// 	hideY: true,
			// };
			var d = {
				"values": [[]],
				"xLabels": ['Count'],
				"yLabels": [],
			};
			for (var l in consensusTot) {
				scolors.push(stateColor[l]);
				d.yLabels.push(l);
				d.values[0].push(consensusTot[l])
			}

			let xDataArray = [];

		if(d.values.length > 1){
			for(let [index, xValue] of d.values.entries()){
				let trace = {};
				trace = {
					values: xValue,
					domain: {column: index},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
			}
		}else if(d.values.length == 1){
			let trace = {};
				trace = {
					values: d.values.flat(),
					domain: {column: 0},
					name: 'Count',
					colors: scolors
				}
				xDataArray.push(trace)
		}

		let data = {
            xData : xDataArray,
            labels: d.yLabels,
            container : addChartDiv()[0],
            grid : { rows: Math.ceil((xDataArray.length)/2), columns: xDataArray.length}
        }

		let config = {
			chartTitle: 'Average Consensus Distribution across all tasks',
            size: {
                height: '460',
                width: '600'
            },
		}

		plotly.drawDonutChart(data, config);
		// dash.drawGraphDonut(d, cfg);
		}


		// metrics 
		// console.log('CKMETRICS', descriptor.disableQC, projectType)
		// if (!descriptor.disableQC && projectType == 'NER') {
		if (false) {

			var tableMetrix = $('<table class="mt-4">')
			tableMetrix.html('')
			db.append(tableMetrix);

			if (metricsResult) metricsNext(metricsResult);
			else window.post('metrics', { project: window.GlobalVars.PDFProjectId, host: document.location.host }, metricsNext);
			function metricsNext(res) {

				metricsResult = res;
				function num(v) { return typeof (v) == 'number' ? v : '-'; }
				function fix2(v) { return typeof (v) == 'number' ? v.toFixed(2) : '-'; }
				var desc = {
					title: 'Quality Metrics',
					columns: {
						name: 'Entity Name',
						TP: 'True Positive',
						TN: 'True Negative',
						FP: 'False Positive',
						FN: 'False Negative',
						p: 'Precision',
						r: 'Recall',
						f1: 'F1 Score',
						Kappa: 'Cohen\'s Kappa Score',
					},
					filter: false,
					search: false,
					sort: true,
					initialSort: 'name',
					initialSortDir: -1,
					pageSize: 10,
					noFilter: null,
					noSearch: null,
					noSort: null,
					centerCol: ['TP', 'TN', 'FP', 'FN', 'p', 'r', 'f1', 'Kappa'],
					formatCol: {
						TP: num,
						TN: num,
						FP: num,
						FN: num,
						p: fix2,
						r: fix2,
						f1: fix2,
						Kappa: fix2,
					},
					forceType: {
						TP: 1,
						TN: 1,
						FP: 1,
						FN: 1,
						p: 1,
						r: 1,
						f1: 1,
						Kappa: 1,
					},
				}
				var tabMetrics = tabler.table(tableMetrix, desc, null);
				if (typeof (res.data) == 'string') {
					try {
						res.data = JSON.parse(res.data);

					} catch (e) { res.data = {} };
				}
				console.log('METRICS', res.data)
				var metricsEntity = {};
				for (var k in res.data) {
					var kdata = res.data[k];
					for (var e of kdata) {
						var name = e[0];
						if (!metricsEntity[name]) metricsEntity[name] = { name: name };
						for (var mk in e[1]) metricsEntity[name][mk] = e[1][mk];
					}
				}
				for (var en of Object.values(metricsEntity)) tabMetrics.addRow(en);
				tabMetrics.draw();
			}
		}


		function minutes(v) {
			return Math.floor(v / 60) + ' min.';
		}


		function seconds(v) {
			return Math.floor(v) + ' sec.';
		}


		if( !trainingType ) {
			var divAn = $('<table class="mt-4">')
			divAn.html('annot')
			db.append(divAn);
	
			var desc = {
				title: 'Annotators Throughput',
				columns: {
					name: 'Name',
					email: 'Email',
					tasks: 'Total Tasks',
					totalTIme: 'Total Time',
					avgTime: 'Avg. Time',
				},
				filter: false,
				search: false,
				sort: true,
				initialSort: 'avgTime',
				initialSortDir: -1,
				pageSize: 10,
				noFilter: null,
				noSearch: null,
				noSort: null,
				centerCol: ['tasks', 'totalTime', 'avgTime'],
				format: tabler.formatString,
				formatCol: {
					totalTIme: seconds,
					avgTime: seconds,
				}
			}
			var tabAnnotator = tabler.table(divAn, desc, 'annotatorThroughput');
			for (var a in annotators) {
				tabAnnotator.addRow({
					name: aname[a],
					email: a,
					tasks: annotators[a].tasks,
					totalTIme: annotators[a].elapsedTime,
					avgTime: annotators[a].elapsedTime / annotators[a].tasks,
				})
			}
			tabAnnotator.draw();
			console.log('TABANNOTATOR', tabAnnotator)
	
	
			if (Object.keys(qcs).length) {
				var divQc = $('<table class="mt-4">')
				divQc.html('qc')
				db.append(divQc);
	
				var desc = {
					title: 'QCs Throughput',
					columns: {
						name: 'Name',
						email: 'Email',
						tasks: 'Total Tasks',
						totalTIme: 'Total Time',
						avgTime: 'Avg. Time',
					},
					filter: false,
					search: false,
					sort: true,
					initialSort: 'avgTime',
					initialSortDir: -1,
					pageSize: 10,
					noFilter: null,
					noSearch: null,
					noSort: null,
					centerCol: ['tasks', 'totalTime', 'avgTime'],
					format: tabler.formatString,
					formatCol: {
						totalTIme: seconds,
						avgTime: seconds,
					}
				}
				var tabQc = tabler.table(divQc, desc, 'annotatorThroughput');
				for (var a in qcs) {
					tabQc.addRow({
						name: aname[a],
						email: a,
						tasks: qcs[a].tasks,
						totalTIme: qcs[a].elapsedTime,
						avgTime: qcs[a].elapsedTime / qcs[a].tasks,
					})
				}
				tabQc.draw();
			}
		}
		else {
			var divAn = $('<table class="mt-4">')
			divAn.html('annot')
			db.append(divAn);
	
			var desc = {
				title: 'Label Throughput',
				columns: {
					name: 'Name',
					email: 'Email',
					tasks: 'Total Tasks',
					totalTIme: 'Total Time',
					state: 'State',
					score: 'Score',
					// updated: 'Last Annotation',
				},
				filter: false,
				search: true,
				sort: true,
				initialSort: 'updated',
				initialSortDir: 1,
				pageSize: 10,
				noFilter: null,
				noSearch: null,
				noSort: null,
				centerCol: ['tasks', 'totalTime', 'avgTime'],
				format: tabler.formatString,
				forceType: { totalTIme: 1, updated: 1, score: 1, tasks: 1 },

				formatCol: {
					totalTIme: seconds,
					avgTime: seconds,
					updated: frm.localDateTime,
					score: function(v){ return defined(v) ? Math.floor(v)+'%' : '' },
				}
			}

			if( trainingType == 1 ) delete desc.columns.score;
			var tabAnnotator = tabler.table(divAn, desc, 'annotatorThroughput');
			console.log( 'annotatorScore-----------', annotatorScore, annotators )
			for (var a in annotatorScore) {
				console.log( 'aaaaaaaaaaa', a, annotators[a] )
				tabAnnotator.addRow({
					name: aname[a],
					email: a,
					tasks: annotators[a].tasks,
					totalTIme: annotators[a].elapsedTime,
					score: annotatorScore[a].score,
					state: annotatorScore[a].state,
					updated: annotatorScore[a].updated,
				})
			}
			tabAnnotator.draw();
			console.log('TABANNOTATOR', tabAnnotator)
		}





		$('text').css({ fill: '#000000' })

	}

	function dashFunc() {
		var dashBut = $('#dashboardButton');
		dashboardVisible = !dashboardVisible;
		if (dashboardVisible) {
			$('.imgcls-toolbar').css({ height: $('.imgcls-toolbar-commands').outerHeight() + 10 })
			dashBut.html('Hide Dashboard');
			$('.imgcls-toolbar').children().hide();
			$('.imgcls-browse').hide();
			$('.imgcls-toolbar-commands').show();
			$('#dashboard').show();
			dashboard()
			$(window).off('resize');
			$('#root').css({ height: 'auto', overflow: 'auto' })
		}
		else {
			$('.imgcls-toolbar').css({ height: '' })
			$('.imgcls-toolbar').children().show();
			$('.imgcls-browse').show();
			dashBut.html('Dashboard');
			$('#dashboard').hide();
			bulk.setResize()
		}
	}

	function getProject(callback) {
		var pmatch = { id: global.PDFProjectId };
		window.post('find_projects', { match: pmatch }, function (pres) {
			projectData = pres.data.records[0];
			frm.dotKeys(projectData);
			console.log( 'PROJECTDATA', projectData )
			callback();
		})
	}


	descriptor.adminEdit = window.hasPriv('admin', 'c_admin', 'c_super');
	descriptor.gridLayout.rolloverPreview = true;

	function start() {
		var cfg = window.getPageParams();
		var projectId = global.PDFProjectId;
		frm.loading('Loading Tasks')
		descriptor.presignedConfig = { project: projectId };
		var match = { project: projectId };
		descriptor.baseMatch = { type: 'project', match: match, 'key': 'fileId' };
		console.log('baseMatch', descriptor.baseMatch)


		var getSize = 200000;
		var getSize = 200;
		descriptor.progressiveLoad = function (config, callback) {
			var start = config.start;
			var filter = config.filter;
			var end = config.end || 0;
			var limit = end > 0 ? end - start + 1 : getSize;
			if (!filter) filter = {};
			if( !config.noLoading ) frm.loading('Loading Tasks');
			var gmatch = clone(descriptor.baseMatch.match);
			if (Object.keys(filter).length) gmatch.filter = filter;
			gmatch._start = start;
			gmatch._limit = limit;
			console.log('GMATCH', JSON.stringify(gmatch))
			window.post('bulk_tasks', { bulkProject: projectId, match: gmatch }, res => {
				descriptor.filterData = res.data.filter;
				res.data.records = res.data.tasks;
				if (res.data.start == 0) {
					descriptor.dataset = [];
					descriptor.dataset[res.data.count - 1] = null;
				}
				if (res.data.training) {
					descriptor.trainingType = res.data.training.type;
				}
				descriptor.labels = [];
				if (res.data.labels){
					for (var l of Object.values(res.data.labels)) {
						descriptor.labels.push({ label: l.name });
					}				
				}
				for (var i = 0; i < res.data.records.length; i++)
					descriptor.dataset[i + start] = res.data.records[i];
				if (descriptor.dataset.length == 0 && !Object.keys(filter).length) {
					frm.loadingOut();
					error('No documents found')
					return callback(res.data.records);
				}
				frm.loadingOut();
				callback(res.data.records);
			})
		}

		getProject(function () {

			if (!window.hasPriv('admin', 'c_admin', 'c_super')) descriptor.blockEdit = true;

			descriptor.dashboardFunc = dashFunc;
			descriptor.projectData = projectData;
			descriptor.projectId = projectData.id;
			descriptor.configId = 'pr-' + projectId;
			descriptor.config = cfg.cfg || ((global.config || {})[descriptor.configId] || '');
			descriptor.configLock = cfg.cfg > '';
			descriptor.dashboardUpdate = function () {
				getProject(function () { })
			};

			descriptor.dataset = [];
			var ftr = bulk.initFilter(descriptor);
			console.log( 'ftr', ftr )
			descriptor.progressiveLoad({
				start:0, 
				filter: ftr,
			}, () => {
				bulk.init(descriptor)
			})

			// bulk.init(descriptor)
			// frm.loadingOut();
		})


		// window.post('bulk_tasks', { bulkProject: projectId, match: match }, res => {
		// 	descriptor.dataset = res.data.tasks;
		// 	console.log('BULK', res.data)
		// 	if (descriptor.dataset.length == 0) {
		// 		frm.loadingOut();
		// 		return error('No documents found')
		// 	}
		// 	if (res.data.training) {
		// 		descriptor.trainingType = res.data.training.type;
		// 	}
		// 	descriptor.labels = [];
		// 	for (var l of Object.values(res.data.labels)) {
		// 		descriptor.labels.push({ label: l.name });
		// 	}
		// 	// console.log( 'descriptor', descriptor )
		// 	getProject(function () {

		// 		if (!window.hasPriv('admin', 'c_admin', 'c_super')) descriptor.blockEdit = true;

		// 		descriptor.dashboardFunc = dashFunc;
		// 		descriptor.projectData = projectData;
		// 		descriptor.projectId = projectData.id;
		// 		descriptor.configId = 'pr-' + projectId;
		// 		descriptor.config = cfg.cfg || ((global.config || {})[descriptor.configId] || '');
		// 		descriptor.configLock = cfg.cfg > '';
		// 		descriptor.dashboardUpdate = function () {
		// 			getProject(function () { })
		// 		};
		// 		bulk.init(descriptor)
		// 		frm.loadingOut();
		// 	})
		// })
	}

	useEffect(start);

	return (
		<>
			<div fluid="md p-0" className="imgcls-main maincontent">
				<div className="imgcls-toolbar hidden">
					<div className="imgcls-toolbar-commands"></div>
					<div className="imgcls-toolbar-filters"></div>
					<div className="imgcls-toolbar-sort"></div>
					<div className="imgcls-toolbar-tabs"></div>
					<div className="imgcls-toolbar-controls">
						<div className="imgcls-toolbar-sliders"></div>
						<div className="imgcls-toolbar-nav-placeholder"></div>
						<div className="imgcls-toolbar-nav"></div>
						<div className="imgcls-toolbar-buttons-placeholder"></div>
						<div className="imgcls-toolbar-buttons">
							<span className="selected-images"></span>
						</div>
					</div>
				</div>
				<div id="dashboard"></div>
				<div className="imgcls-browse">
				</div>
			</div>
		</>
	)
}

export default BulkBrowse;
